import { InputOption } from "../../../web-components/src/atoms/input/types";
import { DropdownMultiSelect } from "@avenueops/web-components";
import React from "react";
import { useController } from "react-hook-form";

interface Props {
  name: string;
  title?: string;
  required?: boolean;
  control: any;
  shouldUnregister?: boolean;
  options?: InputOption<string>[];
}

export default function EmailMultiInput({ name, title, control, shouldUnregister, options }: Props) {
  const {
    field: { onChange, onBlur, ref, value },
    fieldState: { error, isDirty, isTouched },
  } = useController({ name, control, shouldUnregister });

  return (
    <DropdownMultiSelect
      title={title}
      error={error ? { message: "Invalid email address" } : undefined}
      dirty={isDirty}
      touched={isTouched}
      ref={ref}
      onBlur={onBlur}
      name={`_${name}`}
      options={options ?? []}
      placeholder="richard@piedpiper.com"
      selectedValues={value}
      onChange={onChange}
      onCreate={(searchText: any) => {
        return { label: searchText, value: searchText };
      }}
    />
  );
}
